import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, HostBinding } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
  ActivatedRoute,
  Router,
  RouterLink,
  RouterOutlet,
} from '@angular/router';
import {
  FaIconLibrary,
  FontAwesomeModule,
} from '@fortawesome/angular-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { faHeart as faHeartRegular } from '@fortawesome/free-regular-svg-icons';
import {
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faAngleLeft,
  faAngleRight,
  faArrowLeft,
  faArrowRight,
  faArrowRightToBracket,
  faArrowUpRightFromSquare,
  faBars,
  faCalendar,
  faCalendarCheck,
  faCalendarDays,
  faCalendarXmark,
  faCaretDown,
  faCheck,
  faCheckCircle,
  faChevronCircleDown,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircleExclamation,
  faClock,
  faClockRotateLeft,
  faClone,
  faCog,
  faCopy,
  faDesktop,
  faDollarSign,
  faDownload,
  faEllipsisH,
  faEllipsisV,
  faEllipsisVertical,
  faEnvelope,
  faFileExport,
  faFilter,
  faGlobe,
  faHeart,
  faHouse,
  faLanguage,
  faLink,
  faLock,
  faLockOpen,
  faMapLocationDot,
  faPen,
  faPhoneFlip,
  faPlus,
  faQrcode,
  faQuestionCircle,
  faSearch,
  faShoppingBag,
  faSlidersH,
  faSquareXmark,
  faSync,
  faTags,
  faThumbTack,
  faTimes,
  faTimesCircle,
  faTrash,
  faUser,
  faUsers,
} from '@fortawesome/free-solid-svg-icons';
import { ImageViewerComponent } from './common/components/image.viewer/image.viewer.component';
import { LoaderComponent } from './common/loader/loader.component';
import { PeopleUtilsMixin } from './common/people_utils';
import { EmptyObject } from './common/utils';
import { AppPermissions } from './core/permissions';
import { DEBUG, SessionService } from './session.service';

@Component({
  selector: 'app-root',
  standalone: true,
  templateUrl: './app.component.html',
  imports: [
    CommonModule,
    RouterOutlet,
    RouterLink,
    LoaderComponent,
    FontAwesomeModule,
    MatMenuModule,
    ImageViewerComponent,
  ],
})
export class AppComponent extends PeopleUtilsMixin(EmptyObject) {
  @HostBinding('class') css = 'max-height';
  debug = DEBUG;
  _common = _common;

  drawerOpened = false;
  constructor(
    public session: SessionService,
    private router: Router,
    private route: ActivatedRoute,
    private http: HttpClient,
    private snackBar: MatSnackBar,
    library: FaIconLibrary
  ) {
    super();
    // Add an icon to the library for convenient access in other components
    library.addIcons(faEllipsisH);
    library.addIcons(faEllipsisV);
    library.addIcons(faSlidersH);
    library.addIcons(faSearch);
    library.addIcons(faSync);
    library.addIcons(faChevronUp);
    library.addIcons(faChevronDown);
    library.addIcons(faChevronRight);
    library.addIcons(faChevronLeft);
    library.addIcons(faTimes);
    library.addIcons(faPlus);
    library.addIcons(faFileExport);

    library.addIcons(faPen);
    library.addIcons(faTrash);
    library.addIcons(faAngleDoubleLeft);
    library.addIcons(faAngleDoubleRight);
    library.addIcons(faAngleLeft);
    library.addIcons(faAngleRight);
    library.addIcons(faCalendarCheck);
    library.addIcons(faCheck);
    library.addIcons(faCalendar);
    library.addIcons(faClone);
    library.addIcons(faUser);
    library.addIcons(faUsers);
    library.addIcons(faPhoneFlip);
    library.addIcons(faMapLocationDot);
    library.addIcons(faClock);
    library.addIcons(faHouse);
    library.addIcons(faLink);
    library.addIcons(faCalendarDays);
    library.addIcons(faThumbTack);
    library.addIcons(faBars);
    library.addIcons(faArrowRightToBracket);
    library.addIcons(faCaretDown);
    library.addIcons(faLanguage);
    library.addIcons(faGlobe);
    library.addIcons(faEllipsisVertical);
    library.addIcons(faArrowRight);
    library.addIcons(faCog);
    library.addIcons(faEnvelope);
    library.addIcons(faHeart);
    library.addIcons(faQrcode);
    library.addIcons(faHeartRegular);
    library.addIcons(faCalendarXmark);
    library.addIcons(faCheckCircle);
    library.addIcons(faTimesCircle);
    library.addIcons(faCopy);
    library.addIcons(faWhatsapp);
    library.addIcons(faTags);
    library.addIcons(faFilter);
    library.addIcons(faShoppingBag);
    library.addIcons(faSquareXmark);
    library.addIcons(faArrowLeft);
    library.addIcons(faLockOpen);
    library.addIcons(faLock);
    library.addIcons(faChevronCircleDown);
    library.addIcons(faDollarSign);
    library.addIcons(faClockRotateLeft);
    library.addIcons(faDownload);
    library.addIcons(faCircleExclamation);
    library.addIcons(faDesktop);
    library.addIcons(faQuestionCircle);
    library.addIcons(faArrowUpRightFromSquare);
  }

  authCode: string;
  source: string;
  ngOnInit() {
    let params = new URLSearchParams(window.location.search);
    let authCode = params.get('authCode');
    this.authCode = authCode;
    let source = params.get('source');
    if (source == 'app' && authCode) {
      this.session.vpLogin(authCode);

    }
  }
  login() {
    this.session.login();
  }
  logout() {
    this.session.logout();
  }
  changeLocale(locale: string) {
    let href = window.location.href;
    console.log(href);
    let url = new URL(href);
    let path = url.pathname;
    if (path.startsWith('/en/')) {
      path = path.substring(3);
    }
    if (path.startsWith('/zh_hk/')) {
      path = path.substring(6);
    }
    if (path.startsWith('/zh_cn/')) {
      path = path.substring(6);
    }
    path = `/${locale}${path}${window.location.search}`;

    window.location.href = path;

    // this.session.changeLocale(locale);
  }

  permissions = AppPermissions;
}
